import { render, staticRenderFns } from "./DispatchAlertLogs.vue?vue&type=template&id=6409379b"
import script from "./DispatchAlertLogs.vue?vue&type=script&lang=js"
export * from "./DispatchAlertLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports